/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { FaEllipsisV, FaRegEye, FaExternalLinkAlt } from "react-icons/fa";
import "../../App.css";
import {
  Button,
  Dropdown,
  Menu,
  Modal,
  Space,
  Tooltip,
  Typography,
  message,
  Pagination,
} from "antd";
import { useEffect, useState, useMemo, useCallback } from "react";
import SideBar from "../sidebar/SideBar";
import AddressFormadmin from "../forms/AddressFormadmin";
import { useMutation, useQuery } from "@tanstack/react-query";
import { deleteDoc, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../config/firebase";
import { toast } from "react-toastify";
import EditQuotesForm from "../forms/editQuoteForm";
import { Link, useNavigate } from "react-router-dom";
import { generatePDF } from "../shared/pdf/generatePDF";
import Search from "../../icons/Search";
import { getRequests } from "../../lib/newRequest";
import {
  FilePdfTwoTone,
  FileExcelTwoTone,
  FileUnknownTwoTone,
} from "@ant-design/icons";
import DescriptionModal from "./DescriptionModal";
import DashboardLayout from "../layout";
import Header from "../header/Header";
import { api } from "../../config/api";
import { useMyContext } from "../../context/MyContext";
import { downloadAttachment } from "../../utils/downloadAttachment";
import Estimations from "./Estimations";
import { useLocation } from "react-router-dom";
import Loader from "../shared/loader/loader";
import ExternalUrlModal from "../externalEstimateURL/ExternalURLModal";
import GuestEstimates from "./GuestEstimates";
import WebsiteCalculatorEstimates from "./WebsiteCalculatorEstimates";

function NewRequest() {
  const [createquote, setcreatequote] = useState(false);
  const [menuVisible, setMenuVisible] = useState(false);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRequestId, setSelectedRequestId] = useState(null);
  const [externalUrlModalVisible, setExternalUrlModalVisible] = useState(false);

  const { notifications } = useMyContext();
  const [currency, setCurrency] = useState("USD");

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tabParam = searchParams.get("tab");
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (tabParam === "estimates") {
      setActiveView("estimates");
    } else if (tabParam === "proposals") {
      setActiveView("proposals");
    } else if (tabParam === "external-estimates") {
      setActiveView("externalEstimates");
    }
  }, [tabParam]);

  const handleCurrencyChange = (selectedCurrency) => {
    setCurrency(selectedCurrency);
  };

  useEffect(() => {
    if (notifications && notifications.length > 0) {
      notifications.forEach((notification) => { });
    }
  }, [notifications]);

  const handleMenuClick = ({ key }) => {
    if (key === "edit") {
    } else if (key === "delete") {
      setShowDeleteConfirmationModal(true);
    }
    setMenuVisible(!menuVisible);
  };

  useEffect(() => {
    const closeMenuOnOutsideClick = (event) => {
      if (menuVisible) {
        const dropdownContainer = document.querySelector(".ant-dropdown");
        if (dropdownContainer && !dropdownContainer.contains(event.target)) {
          setMenuVisible(false);
        }
      }
    };

    document.body.addEventListener("click", closeMenuOnOutsideClick);

    return () => {
      document.body.removeEventListener("click", closeMenuOnOutsideClick);
    };
  }, [menuVisible]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleDelete = (id) => {
    setSelectedRequestId(id);
    setShowDeleteConfirmationModal(true);
  };

  const confirmDelete = () => {
    deleteMutation.mutate(selectedRequestId);
  };

  const deleteMutation = useMutation(
    async (id) => {
      if (!id) return;
      try {
        const requestRef = doc(db, "requests", id);
        await deleteDoc(requestRef);
        setShowDeleteConfirmationModal(false);
        refetch();
      } catch (error) {
        console.error("Error deleting request", error);
        if (error.code === "not-found") {
          toast.warning("Request not found");
        } else {
          toast.error(`Could not delete request: ${error.message}`);
        }
      }
    },
    {
      onSuccess: () => {
        message.success("Deleted successfully!");
      },
    }
  );

  const [selectId, setSelectId] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const navigate = useNavigate();

  const handleEdit = (id) => {
    navigate(`/editQuotes/${id}`);
  };

  function formatDate(dateString) {
    const options = { year: "numeric", month: "short", day: "numeric" };
    const formattedDate = new Date(dateString).toLocaleDateString(
      undefined,
      options
    );
    return formattedDate;
  }

  const [activeView, setActiveView] = useState("newInquiries");
  const [searchQuery, setSearchQuery] = useState("");
  // const [filteredData, setFilteredData] = useState([]);

  const { data, isLoading: dataLoading, refetch } = useQuery(
    ["request", activeView], // Add activeView as a query key
    async () => {
      try {
        const res = await getRequests();
        return res;
      } finally {
      }
    },
    {
      refetchOnWindowFocus: true, // Changed from false to true
      refetchOnMount: true, // Added to refetch when component mounts
      refetchOnReconnect: true, // Added to refetch when reconnecting
      staleTime: 0, // Changed from 5 minutes to 0 for real-time updates
      cacheTime: 5 * 60 * 1000, // Reduced from 10 minutes to 5 minutes
      refetchInterval: 30000, // Added polling every 30 seconds for real-time updates
      refetchIntervalInBackground: true, // Continue polling even when tab is not active
      // Only fetch if we're viewing newInquiries tab
      enabled: activeView === "newInquiries",
    }
  );

  const filteredData = useMemo(() => {
    if (!data) return [];

    if (searchQuery.trim() === "") return data;

    return data.filter((directory) =>
      Object.values(directory).some(
        (value) =>
          typeof value === "string" &&
          value.toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  }, [searchQuery, data]);

  const handleTabChange = useCallback((view) => {
    setActiveView(view);
    setCurrentPage(1);
    setSearchQuery("");
  }, []);

  const handleNewInquiriesClick = () => handleTabChange("newInquiries");
  const handleProposalsClick = () => handleTabChange("proposals");
  const handleEstimatesClick = () => handleTabChange("estimates");
  const handleExternalEstimatesClick = () => handleTabChange("externalEstimates");
  const handleWebsiteCalculatorClick = () => handleTabChange("websiteCalculator");

  const handleExternalUrl = () => {
    setExternalUrlModalVisible(true);
  };

  const handleExternalUrlSuccess = () => {
    // This function will be called when an external URL is successfully created
    // Can be used to refresh data or update UI if needed
    if (activeView === "newInquiries") {
      refetch(); // Refetch data when external URL is created
    }
  };

  const handleButtonClicked = (view) => {
    setActiveView(view);
    setSearchQuery(""); // Clear search query when changing view
  };

  const hasManualData = (quote) => {
    if (!quote) return false;
    const hasLoad = Boolean(quote.loadAddress || quote.loadCountry || quote.loadCity || quote.loadName);
    const hasItems = Array.isArray(quote.items) && quote.items.length > 0;
    const hasPkg = Array.isArray(quote.pcsPackage) && quote.pcsPackage.length > 0;
    return hasLoad || hasItems || hasPkg;
  };

  const getFileIcon = (file) => {
    if (
      file.type === "application/pdf" ||
      file.name.toLowerCase().endsWith(".pdf")
    ) {
      return <FilePdfTwoTone twoToneColor={"red"} />;
    } else if (
      file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      file.type === "application/vnd.ms-excel" ||
      file.name.toLowerCase().endsWith(".xlsx") ||
      file.name.toLowerCase().endsWith(".xls")
    ) {
      return <FileExcelTwoTone twoToneColor={"green"} />;
    } else {
      return <FileUnknownTwoTone />;
    }
  };

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  // Pagination logic
  const getPaginatedData = (data) => {
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return data.slice(startIndex, endIndex);
  };

  // Add effect to refetch when notifications change (indicating new data)
  useEffect(() => {
    if (notifications && notifications.length > 0 && activeView === "newInquiries") {
      const hasNewInquiry = notifications.some(
        notification => notification.type === "new-inquiry" && !notification.read
      );
      if (hasNewInquiry) {
        refetch();
      }
    }
  }, [notifications, activeView, refetch]);

  // SWAPPED: Changed the order and labels of tabs
  const headerTabs = [
    { title: "New Inquiries", key: "newInquiries", onClick: handleNewInquiriesClick },
    { title: "TradeOS™ Quotations", key: "estimates", onClick: handleEstimatesClick },
    { title: "Proposals", key: "proposals", onClick: handleProposalsClick },
    { title: "External Estimates", key: "externalEstimates", onClick: handleExternalEstimatesClick },
    { title: "Website Calculator", key: "websiteCalculator", onClick: handleWebsiteCalculatorClick },
  ]

  return (
    <>
      <Modal
        title="Confirm Delete"
        visible={showDeleteConfirmationModal}
        onOk={confirmDelete}
        onCancel={() => setShowDeleteConfirmationModal(false)}
        okText="Yes"
        cancelText="No"
      >
        <p>Are you sure you want to delete this request?</p>
      </Modal>
      <Modal
        title="Comment"
        open={isModalOpen}
        onOk={handleOk}
        centered
        footer={false}
        onCancel={handleCancel}
      >
        <textarea className="w-full h-[100px] border border-[gray] p-2 rounded-[8px] focus:outline-none" />
        <button className="mt-4 w-[130px] text-[#fff] rounded-[8px] h-[40px] bg-[#03336e]">
          Send
        </button>
      </Modal>

      {/* External URL Modal */}
      <ExternalUrlModal
        isVisible={externalUrlModalVisible}
        onClose={() => setExternalUrlModalVisible(false)}
        onSuccess={handleExternalUrlSuccess}
      />

      <DashboardLayout>
        <div className="w-full">
          <Header title="New Requests" />
          <div className="p-2 bg-cus-gray">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-3 bg-white rounded-md md:p-5 gap-4 sm:gap-0">
              {/* Left side - Buttons */}
              <div className="flex items-center space-x-1 sm:space-x-2 w-full sm:w-auto sm:mr-4">
                {headerTabs.map((tab) => (
                  <button
                    key={tab.key}
                    onClick={tab.onClick}
                    className={`flex-shrink-0 whitespace-nowrap rounded-[5px] items-center space-x-1 sm:space-x-2 py-1 sm:py-2 px-2 sm:px-3 text-white text-xs sm:text-sm font-medium transition-colors ${activeView === tab.key ? "btnBg shadow-lg shadow-[#6478b0]" : "bg-gray-400 hover:bg-gray-500"
                      }`}
                  >
                    <span>{tab.title}</span>
                  </button>
                ))}

              </div>

              {/* Right side - External URL Button + Search Bar */}
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center space-y-2 sm:space-y-0 w-full sm:w-auto">
                {/* External URL Button with Tooltip */}
                <Tooltip title="Create estimation URL for users who are not One Union Solutions clients and external link / Guest Estimate Link">
                  <button
                    onClick={handleExternalUrl}
                    className="btnBg text-white p-2 rounded-md text-xs sm:text-sm flex items-center justify-center gap-1 sm:gap-2 flex-1 sm:flex-none order-2 sm:order-1 sm:mr-6"
                  >
                    <FaExternalLinkAlt />
                    <p className="hidden sm:inline">External URL</p>
                    <p className="sm:hidden text-xs">Ext. URL</p>
                  </button>
                </Tooltip>

                {/* Search Bar */}
                <div className="relative flex items-center w-full sm:w-auto min-w-0 max-w-xs rounded-[5px] border-2 border-blue focus-within:border-blue-500 transition-colors order-1 sm:order-2">
                  <div className="flex-shrink-0 p-2 pointer-events-none">
                    <Search className="w-4 h-4 text-gray-400 flex-shrink-0" />
                  </div>
                  <input
                    className="outline-none flex-1 bg-transparent px-2 py-1 text-xs sm:text-sm placeholder-gray-500 min-w-0"
                    placeholder="Search here"
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* New Inquiries Tab */}
            {activeView === "newInquiries" && (
              <div className="flex items-center justify-between px-0 py-3 mt-4 bg-white rounded-md md:py-5">
                <div className="w-full">
                  {/* Table with thead always visible */}
                  <table className="w-full text-sm text-center">
                    <thead className="text-[#00000096] font-normal">
                      <tr className="border-b-2 ">
                        <th className="p-1">Company</th>
                        <th className="p-1">Inquire Number</th>
                        <th className="p-1">View</th>
                        <th className="p-1">Date</th>
                        <th className="p-1 w-40 pl-4 pr-4">Status</th>
                        <th className="p-1">Action</th>
                      </tr>
                    </thead>

                    {/* Table Body - Loader shows here only */}
                    <tbody>
                      {dataLoading ? (
                        <tr>
                          <td colSpan={6} className="h-96">
                            <div className="flex justify-center items-center h-full">
                              <Loader />
                            </div>
                          </td>
                        </tr>
                      ) : filteredData && filteredData.length === 0 ? (
                        <tr>
                          <td colSpan={6} className="py-20 text-center text-gray-500">
                            No inquiries found
                          </td>
                        </tr>
                      ) : (
                        getPaginatedData(filteredData).map((quote, index) => (
                          <tr key={index} className="border-b-2 py-2 bg-white">
                            <td className="p-1">{quote.name}</td>
                            <td className="p-1">{quote?.inquireNumber}</td>
                            <td className="p-1">
                              {quote?.isInvoiceUpload ? (
                                <>
                                  {quote.uploadFileData
                                    ?.slice(0, 3)
                                    .map((file, fileIndex) => (
                                      <Tooltip key={fileIndex} title={file.name}>
                                        <Button
                                          icon={getFileIcon(file)}
                                          onClick={() => {
                                            downloadAttachment(file.url, file.name).catch(() => {
                                              toast.error("Unable to download file. Please try again.");
                                            });
                                          }}
                                          style={{ marginRight: "5px" }}
                                        />
                                      </Tooltip>
                                    ))}
                                  {quote.uploadFileData?.length > 3 && (
                                    <Tooltip
                                      title={`${quote.uploadFileData.length - 3
                                        } more file(s)`}
                                    >
                                      <Button>
                                        +{quote.uploadFileData.length - 3}
                                      </Button>
                                    </Tooltip>
                                  )}
                                  <DescriptionModal data={quote} />
                                  {hasManualData(quote) && (
                                    <Tooltip title="View full request">
                                      <button
                                        data-tooltip-id="view"
                                        onClick={() =>
                                          navigate(`/editRequest/${quote.id}`)
                                        }
                                        className="py-1 px-3 rounded-md bg-[#A9A9A9] text-white ml-1 align-middle"
                                      >
                                        <FaRegEye className="text-2xl" />
                                      </button>
                                    </Tooltip>
                                  )}
                                </>
                              ) : (
                                <button
                                  data-tooltip-id="view"
                                  onClick={() =>
                                    navigate(`/editRequest/${quote.id}`)
                                  }
                                  className="py-1 px-3 rounded-md bg-[#A9A9A9] text-white"
                                >
                                  <FaRegEye className="text-2xl" />
                                </button>
                              )}
                            </td>
                            <td className="p-1">
                              {formatDate(quote.creationDate)}
                            </td>
                            <td className="p-1">
                              <div className="flex items-center justify-space-between space-x-2">
                                <button
                                  className="border capitalize rounded-md p-1 text-black bg-[#e5edfb] w-24">
                                  {quote.requestStatus}
                                </button>
                                {notifications.some(
                                  (notification) =>
                                    notification.quoteNumber === quote.inquireNumber &&
                                    notification.type === "updated-inquiry"
                                ) &&
                                  quote.requestStatus.toLowerCase() === "unquoted" && (
                                    <button
                                      className="border capitalize rounded-md p-1 text-black bg-[#EAE4DD] w-24"
                                      title="Updated Inquiry"
                                    >
                                      Updated
                                    </button>
                                  )}
                              </div>
                            </td>

                            <td className="p-1">
                              <Dropdown
                                overlay={
                                  <Menu onClick={handleMenuClick}>
                                    <Menu.Item key="edit" onClick={() => navigate(`/addQuoteFromRequest/${quote.id}`)}>
                                      <Space>+ Create Quote</Space>
                                    </Menu.Item>
                                    <Menu.Item key="delete" onClick={() => handleDelete(quote.id)}>
                                      <Space>Delete</Space>
                                    </Menu.Item>
                                  </Menu>
                                }
                                visible={openDropdownIndex === index}
                                trigger={["click"]}
                                onVisibleChange={(visible) => {
                                  setOpenDropdownIndex(visible ? index : null);
                                }}
                              >
                                <a
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setOpenDropdownIndex(index);
                                  }}
                                >
                                  <Space>
                                    <button className="border relative p-1 rounded-md border-[#053F92]">
                                      <FaEllipsisV />
                                      {notifications?.some(
                                        (e) =>
                                          e.type === "new-inquiry" &&
                                          e.quoteNumber === quote.inquireNumber &&
                                          e.read === false
                                      ) ? (
                                        <div className="w-2 h-2 absolute -top-[2px] right-0 bg-red-600 rounded-full"></div>
                                      ) : null}
                                    </button>
                                  </Space>
                                </a>
                              </Dropdown>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>

                  {/* Pagination - Only show when not loading and has data */}
                  {!dataLoading && filteredData && filteredData.length > 0 && (
                    <div className="mt-4 flex justify-center">
                      <Pagination
                        current={currentPage}
                        pageSize={pageSize}
                        total={(filteredData || []).length}
                        onChange={handlePageChange}
                        showSizeChanger
                        showQuickJumper
                        showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                      />
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* SWAPPED: Estimates Tab now shows estimationAccept: false (previously Proposals) */}
            {activeView === "estimates" && (
              <Estimations
                searchQuery={searchQuery}
                filterCondition={{ estimationAccept: false }}
              />
            )}

            {/* SWAPPED: Proposals Tab now shows estimationAccept: true (previously Estimates) */}
            {activeView === "proposals" && (
              <Estimations
                searchQuery={searchQuery}
                filterCondition={{ estimationAccept: true }}
              />
            )}

            {/* External Estimates Tab */}
            {activeView === "externalEstimates" && (
              <div className="mt-4">
                <GuestEstimates searchQuery={searchQuery} />
              </div>
            )}

            {activeView === "websiteCalculator" && (
              <div className="mt-4">
                <WebsiteCalculatorEstimates searchQuery={searchQuery} />
              </div>
            )}
          </div>
        </div>
      </DashboardLayout>
    </>
  );
}

export default NewRequest;
